/* eslint-disable camelcase, @typescript-eslint/naming-convention -- mirrors the Rails JSON contract */
import React from 'react';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
import { FlagItem } from './FlagItem';
const NS = 'features.iim_review.tech_performance_drawer';
export function ThisInspectionFlags({ stats, buildingAverageDurationMinutes }) {
    return (React.createElement("section", { className: "tech-performance-drawer__section" },
        React.createElement(Text, { variant: "x-small", as: "h4", className: "tech-performance-drawer__section-title" }, translate('this_inspection', { namespace: NS, defaultValue: 'This Inspection' })),
        React.createElement("ul", { className: "tech-performance-drawer__flags" },
            React.createElement(FlagItem, { icon: "fa-stopwatch", title: translate('duration_flag_title', {
                    namespace: NS,
                    count: stats.duration_minutes,
                    defaultValue: 'Completed in %{count} min'
                }), description: buildingAverageDurationMinutes != null
                    ? translate('duration_flag_desc', {
                        namespace: NS,
                        count: buildingAverageDurationMinutes,
                        defaultValue: '%{count} min average for this inspection type at this building'
                    })
                    : undefined }),
            React.createElement(FlagItem, { icon: "fa-list-check", title: translate('rules_flag_title', {
                    namespace: NS,
                    count: stats.custom_rule_findings_count,
                    defaultValue: '%{count} company rules skipped'
                }), description: stats.custom_rule_findings_count > 0
                    ? translate('rules_flag_desc', {
                        namespace: NS,
                        count: stats.custom_rule_findings_count,
                        defaultValue: 'All %{count} company rule findings on this inspection'
                    })
                    : translate('rules_flag_zeroed_desc', {
                        namespace: NS,
                        defaultValue: 'No company rules skipped on this inspection'
                    }) }),
            stats.featured_rule_finding && (React.createElement(FlagItem, { icon: "fa-list-check", title: translate('featured_rule_title', {
                    namespace: NS,
                    count: stats.featured_rule_finding.count,
                    defaultValue: '%{count} findings flagged by your rule'
                }), description: stats.featured_rule_finding.directive_human })))));
}
